export const PlanActionTypes = {
  FETCH_PLAN_REQUEST: "@@Plan/FETCH_PLAN_REQUEST",
  FETCH_PLAN_SUCCESS: "@@Plan/FETCH_PLAN_SUCCESS",
  FETCH_PLAN_FAILURE: "@@Plan/FETCH_PLAN_FAILURE",

  FETCH_RECHARGES_REQUEST: "@@Plan/FETCH_RECHARGES_REQUEST",
  FETCH_RECHARGES_SUCCESS: "@@Plan/FETCH_RECHARGES_SUCCESS",
  FETCH_RECHARGES_FAILURE: "@@Plan/FETCH_RECHARGES_FAILURE",

  UPDATE_PLAN_REQUEST: "@@Plan/UPDATE_PLAN_REQUEST",
  UPDATE_PLAN_SUCCESS: "@@Plan/UPDATE_PLAN_SUCCESS",
  UPDATE_PLAN_FAILURE: "@@Plan/UPDATE_PLAN_FAILURE",

  FETCH_PLANS_REQUEST: "@@Plan/FETCH_PLANS_REQUEST",
  FETCH_PLANS_SUCCESS: "@@Plan/FETCH_PLANS_SUCCESS",
  FETCH_PLANS_FAILURE: "@@Plan/FETCH_PLANS_FAILURE",

  FETCH_PLAN_MEMBER_REQUEST: "@@Plan/FETCH_PLAN_MEMBER_REQUEST",
  FETCH_PLAN_MEMBER_SUCCESS: "@@Plan/FETCH_PLAN_MEMBER_SUCCESS",
  FETCH_PLAN_MEMBER_FAILURE: "@@Plan/FETCH_PLAN_MEMBER_FAILURE",

  CREATE_PLAN_MEMBER_REQUEST: "@@Plan/CREATE_PLANS_REQUEST",
  CREATE_PLAN_MEMBER_SUCCESS: "@@Plan/CREATE_PLANS_SUCCESS",
  CREATE_PLAN_MEMBER_FAILURE: "@@Plan/CREATE_PLANS_FAILURE",

};

